<template>
	<div style="background: #f2f2f2;">
		<common-head active="0" state="1" @search="search"></common-head>

		<!-- 活动列表 -->
		<index-activity ref="activity" :keyword="keyword"></index-activity>

		<common-footer></common-footer>
	</div>
</template>

<script>
    import { site_name } from '@/static/js/common.js';
	import indexActivity from '@/components/wap/indexActivity.vue';
	import commonHead from '@/components/wap/commonHead.vue';
	import commonFooter from '@/components/wap/commonFooter.vue';
	import { activity_list } from '@/api/activity.js';

	export default {
		name: 'activity',
		components: {
			commonHead, commonFooter,indexActivity
		},
		data() {
			return {
				keyword:'',
			}
		},
		created () {
			this.keyword = this.$route.query.keyword;
		},
		metaInfo() {
            site_name().then(res => {
                document.title = '搜索列表' + '-' + res.site_name;
                return {
                    title: '搜索列表' + '-' + res.site_name,
                    meta: [
                        { name: "keywords", content: "" },
                        { name: "description", content: "" },
                        { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no' }
                    ],
                }
            });
		},
		methods: {
			search(keyword){
				this.keywod = keyword;
				console.log(keyword);
				this.$refs.activity.get_list('',keyword);
			},
		},
	}
</script>
<style scoped>

</style>